import { render } from "./foodBatchShow.vue?vue&type=template&id=4999a728&scoped=true"
import script from "./foodBatchShow.vue?vue&type=script&lang=js"
export * from "./foodBatchShow.vue?vue&type=script&lang=js"

import "./foodBatchShow.vue?vue&type=style&index=0&id=4999a728&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4999a728"]])

export default __exports__